import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { InviteUserRequest } from "../models/User";
import { UserAccount } from "../models/UserAccount";

export const UserApi = {
  listAccounts: async () => {
    return await jwtAuthAxios().get<UserAccount[]>(`/users/accounts`);
  },

  exists: async (email: string) => {
    const escapedEmail = encodeURIComponent(email);
    return await jwtAuthAxios().get<boolean>(
      `/users/exists?email=${escapedEmail}`,
    );
  },

  invite: async (request: InviteUserRequest) => {
    return await jwtAuthAxios().post<undefined>(`/users/invite`, request);
  },
};
